import React from 'react';
import type ProjectSettingsServiceDeskPortalSettingsType from '@atlassian/jira-spa-apps-project-settings-service-desk-portal-settings/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskPortalSettings = lazyForPaint<
	typeof ProjectSettingsServiceDeskPortalSettingsType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-portal-settings", jiraSpaEntry: "async-project-settings-service-desk-portal-settings" */ '@atlassian/jira-spa-apps-project-settings-service-desk-portal-settings'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskPortalSettings}
		pageId="project-settings-portal-settings"
		shouldShowSpinner
	/>
);
